module.exports = __webpack_public_path__ + "static/media/noavailableimage.2b6901da.png";